import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
  type ReactNode,
} from 'react';

type PlacaSearchContextValue = {
  open: boolean;
  setOpen: (v: boolean) => void;
  openSearch: () => void;
};

const PlacaSearchContext = createContext<PlacaSearchContextValue | null>(null);

/** Atalho F2 — busca por placa (docs UX) */
export function PlacaSearchProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);

  const openSearch = useCallback(() => setOpen(true), []);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'F2') {
        e.preventDefault();
        setOpen(true);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  const value = useMemo(
    () => ({
      open,
      setOpen,
      openSearch,
    }),
    [open, openSearch],
  );

  return <PlacaSearchContext.Provider value={value}>{children}</PlacaSearchContext.Provider>;
}

export function usePlacaSearch() {
  const ctx = useContext(PlacaSearchContext);
  if (!ctx) {
    throw new Error('usePlacaSearch deve ser usado dentro de PlacaSearchProvider');
  }
  return ctx;
}
